<template>
  <refonte-card class="!gap-[8px]">
    <h4>Action</h4>
    <div class="flex flex-wrap items-center gap-[16px]">
      <div
        class="refonte-icon"
        title="IconGroup">
        <IconGroup />
      </div>
      <div
        class="refonte-icon"
        title="IconSend">
        <IconSend />
      </div>
      <div
        class="refonte-icon"
        title="IconOpenNewTab">
        <IconOpenNewTab />
      </div>
      <div
        class="refonte-icon"
        title="IconExport">
        <IconExport />
      </div>
      <div
        class="refonte-icon"
        title="IconFilters">
        <IconFilters />
      </div>
      <div
        class="refonte-icon"
        title="IconSearch">
        <IconSearch />
      </div>
      <div
        class="refonte-icon"
        title="IconSettings">
        <IconSettings />
      </div>
      <div
        class="refonte-icon"
        title="IconLogout">
        <IconLogout />
      </div>
      <div
        class="refonte-icon"
        title="IconModify">
        <IconModify />
      </div>
    </div>
    <h4 class="mt-5">Data</h4>
    <div class="flex flex-wrap items-center gap-[16px]">
      <div
        class="refonte-icon"
        title="IconSortIncreasing">
        <IconSortIncreasing />
      </div>
      <div
        class="refonte-icon"
        title="IconSortDecreasing">
        <IconSortDecreasing />
      </div>
      <div
        class="refonte-icon"
        title="IconSort">
        <IconSort />
      </div>
    </div>
    <h4 class="mt-5">Display</h4>
    <div class="flex flex-wrap items-center gap-[16px]">
      <div
        class="refonte-icon"
        title="IconExpand">
        <IconExpand />
      </div>
      <div
        class="refonte-icon"
        title="IconReduce">
        <IconReduce />
      </div>
      <div
        class="refonte-icon"
        title="IconChevronDown">
        <IconChevronDown />
      </div>
      <div
        class="refonte-icon"
        title="IconChevronLeft">
        <IconChevronLeft />
      </div>
      <div
        class="refonte-icon"
        title="IconChevronRight">
        <IconChevronRight />
      </div>
      <div
        class="refonte-icon"
        title="IconChevronUp">
        <IconChevronUp />
      </div>
      <div
        class="refonte-icon"
        title="IconDropListDown">
        <IconDropListDown />
      </div>
      <div
        class="refonte-icon"
        title="IconDropListUp">
        <IconDropListUp />
      </div>
      <div
        class="refonte-icon"
        title="IconArrowLeft">
        <IconArrowLeft />
      </div>
      <div
        class="refonte-icon"
        title="IconArrowRight">
        <IconArrowRight />
      </div>
      <div
        class="refonte-icon"
        title="IconDownload">
        <IconDownload />
      </div>
      <div
        class="refonte-icon"
        title="IconUpload">
        <IconUpload />
      </div>
      <div
        class="refonte-icon"
        title="IconClose">
        <IconClose />
      </div>
      <div
        class="refonte-icon"
        title="IconSeparatorVertical">
        <IconSeparatorVertical />
      </div>
      <div
        class="refonte-icon"
        title="IconSeparatorHorizontal">
        <IconSeparatorHorizontal />
      </div>
      <div
        class="refonte-icon"
        title="IconSignedV1">
        <IconSignedV1 />
      </div>
      <div
        class="refonte-icon"
        title="IconNotSigned">
        <IconNotSigned />
      </div>
      <div
        class="refonte-icon"
        title="IconSignedV2">
        <IconSignedV2 />
      </div>
    </div>
    <h4 class="mt-5">Information</h4>
    <div class="flex flex-wrap items-center gap-[16px]">
      <div
        class="refonte-icon"
        title="IconHelp">
        <IconHelp />
      </div>
      <div
        class="refonte-icon"
        title="IconInformation">
        <IconInformation />
      </div>
      <div
        class="refonte-icon"
        title="IconLocation">
        <IconLocation />
      </div>
      <div
        class="refonte-icon"
        title="IconOnline">
        <IconOnline />
      </div>
      <div
        class="refonte-icon"
        title="IconHourglass">
        <IconHourglass />
      </div>
      <div
        class="refonte-icon"
        title="IconTime">
        <IconTime />
      </div>
      <div
        class="refonte-icon"
        title="IconChart">
        <IconChart />
      </div>
      <div
        class="refonte-icon"
        title="IconLunch">
        <IconLunch />
      </div>
      <div
        class="refonte-icon"
        title="IconFlagParcours">
        <IconFlagParcours />
      </div>
      <div
        class="refonte-icon"
        title="IconDate">
        <IconDate />
      </div>
      <div
        class="refonte-icon"
        title="IconDateRange">
        <IconDateRange />
      </div>
      <div
        class="refonte-icon"
        title="IconMultipleDates">
        <IconMultipleDates />
      </div>
      <div
        class="refonte-icon"
        title="IconDayAgenda">
        <IconDayAgenda />
      </div>
      <div
        class="refonte-icon"
        title="IconCertification">
        <IconCertification />
      </div>
      <div
        class="refonte-icon"
        title="IconTestPositionnement">
        <IconTestPositionnement />
      </div>
      <div
        class="refonte-icon"
        title="IconTestValidation">
        <IconTestValidation />
      </div>
      <div
        class="refonte-icon"
        title="IconList">
        <IconList />
      </div>
      <div
        class="refonte-icon"
        title="IconBell">
        <IconBell />
      </div>
      <div
        class="refonte-icon"
        title="IconEmail">
        <IconEmail />
      </div>
      <div
        class="refonte-icon"
        title="IconPhone">
        <IconPhone />
      </div>
      <div title="IconWarning20">
        <IconWarning20 />
      </div>
      <div title="IconValidate">
        <IconValidate />
      </div>
      <div title="IconValidate20">
        <IconValidate20 />
      </div>
      <div title="IconFailed">
        <IconFailed />
      </div>
    </div>
    <h4 class="mt-5">Menu</h4>
    <div class="flex flex-wrap items-center gap-[16px]">
      <div
        class="refonte-icon"
        title="IconEntities">
        <IconEntities />
      </div>
      <div
        class="refonte-icon"
        title="IconDashboard">
        <IconDashboard />
      </div>
      <div
        class="refonte-icon"
        title="IconTraining">
        <IconTraining />
      </div>
      <div
        class="refonte-icon"
        title="IconBills">
        <IconBills />
      </div>
      <div
        class="refonte-icon"
        title="IconOrders">
        <IconOrders />
      </div>
      <div
        class="refonte-icon"
        title="IconCatalogue">
        <IconCatalogue />
      </div>
      <div
        class="refonte-icon"
        title="IconUser">
        <IconUser />
      </div>
      <div
        class="refonte-icon"
        title="IconParticipants">
        <IconParticipants />
      </div>
    </div>
    <h4 class="mt-5">Profil</h4>
    <div class="flex flex-wrap items-center gap-[16px]">
      <div
        class="refonte-icon"
        title="IconEspace">
        <IconEspace />
      </div>
    </div>
    <h4 class="mt-5">States</h4>
    <div class="flex flex-wrap items-center gap-[16px]">
      <div title="IconPastilleActive">
        <IconPastilleActive />
      </div>
      <div title="IconPastilleWarning">
        <IconPastilleWarning />
      </div>
      <div title="IconPastilleCanceled">
        <IconPastilleCanceled />
      </div>
      <div title="IconPastilleUrgent">
        <IconPastilleUrgent />
      </div>
      <div title="IconPastilleControlleurEc">
        <IconPastilleControlleurEc />
      </div>
      <div title="IconPastilleDeactivated">
        <IconPastilleDeactivated />
      </div>
      <div title="IconPastillePending">
        <IconPastillePending />
      </div>
      <div title="IconPastilleRealised">
        <IconPastilleRealised />
      </div>
      <div title="IconPastilleEntreprise">
        <IconPastilleEntreprise />
      </div>
      <div title="IconPastilleParticipant">
        <IconPastilleParticipant />
      </div>
      <div title="IconPastilleFormateur">
        <IconPastilleFormateur />
      </div>
      <div title="IconPastilleCursus">
        <IconPastilleCursus />
      </div>
    </div>
    <h4 class="mt-5">Users</h4>
    <div class="flex flex-wrap items-center gap-[16px]">
      <div
        class="refonte-icon"
        title="IconNotAttended">
        <IconNotAttended />
      </div>
      <div
        class="refonte-icon"
        title="IconMyAccount">
        <IconMyAccount />
      </div>
      <div
        class="refonte-icon"
        title="IconConventionCollective">
        <IconConventionCollective />
      </div>
      <div
        class="refonte-icon"
        title="IconTrainingProvider">
        <IconTrainingProvider />
      </div>
    </div>
  </refonte-card>
</template>

<script setup lang="ts">
  import IconExport from '@/assets/img/refonte/icons/action/icon-export.svg?component';
  import IconFilters from '@/assets/img/refonte/icons/action/icon-filters.svg?component';
  import IconGroup from '@/assets/img/refonte/icons/action/icon-group.svg?component';
  import IconLogout from '@/assets/img/refonte/icons/action/icon-logout.svg?component';
  import IconModify from '@/assets/img/refonte/icons/action/icon-modify.svg?component';
  import IconOpenNewTab from '@/assets/img/refonte/icons/action/icon-open-new-tab.svg?component';
  import IconSearch from '@/assets/img/refonte/icons/action/icon-search.svg?component';
  import IconSend from '@/assets/img/refonte/icons/action/icon-send.svg?component';
  import IconSettings from '@/assets/img/refonte/icons/action/icon-settings.svg?component';
  import IconSort from '@/assets/img/refonte/icons/data/icon-sort.svg?component';
  import IconSortDecreasing from '@/assets/img/refonte/icons/data/icon-sort-decreasing.svg?component';
  import IconSortIncreasing from '@/assets/img/refonte/icons/data/icon-sort-increasing.svg?component';
  import IconArrowLeft from '@/assets/img/refonte/icons/display/icon-arrow-left.svg?component';
  import IconArrowRight from '@/assets/img/refonte/icons/display/icon-arrow-right.svg?component';
  import IconChevronDown from '@/assets/img/refonte/icons/display/icon-chevron-down.svg?component';
  import IconChevronLeft from '@/assets/img/refonte/icons/display/icon-chevron-left.svg?component';
  import IconChevronRight from '@/assets/img/refonte/icons/display/icon-chevron-right.svg?component';
  import IconChevronUp from '@/assets/img/refonte/icons/display/icon-chevron-up.svg?component';
  import IconClose from '@/assets/img/refonte/icons/display/icon-close.svg?component';
  import IconDownload from '@/assets/img/refonte/icons/display/icon-download.svg?component';
  import IconDropListDown from '@/assets/img/refonte/icons/display/icon-droplist-down.svg?component';
  import IconDropListUp from '@/assets/img/refonte/icons/display/icon-droplist-up.svg?component';
  import IconExpand from '@/assets/img/refonte/icons/display/icon-expand.svg?component';
  import IconNotSigned from '@/assets/img/refonte/icons/display/icon-not-signed.svg?component';
  import IconReduce from '@/assets/img/refonte/icons/display/icon-reduce.svg?component';
  import IconSeparatorVertical from '@/assets/img/refonte/icons/display/icon-separator-vertical.svg?component';
  import IconSeparatorHorizontal from '@/assets/img/refonte/icons/display/icon-separator-horizontal.svg?component';
  import IconSignedV1 from '@/assets/img/refonte/icons/display/icon-signed-v1.svg?component';
  import IconSignedV2 from '@/assets/img/refonte/icons/display/icon-signed-v2.svg?component';
  import IconUpload from '@/assets/img/refonte/icons/display/icon-upload.svg?component';
  import IconBell from '@/assets/img/refonte/icons/information/icon-bell.svg?component';
  import IconCertification from '@/assets/img/refonte/icons/information/icon-certification.svg?component';
  import IconChart from '@/assets/img/refonte/icons/information/icon-chart.svg?component';
  import IconDate from '@/assets/img/refonte/icons/information/icon-date.svg?component';
  import IconDateRange from '@/assets/img/refonte/icons/information/icon-date-range.svg?component';
  import IconDayAgenda from '@/assets/img/refonte/icons/information/icon-day-agenda.svg?component';
  import IconEmail from '@/assets/img/refonte/icons/information/icon-email.svg?component';
  import IconFailed from '@/assets/img/refonte/icons/information/icon-failed.svg?component';
  import IconFlagParcours from '@/assets/img/refonte/icons/information/icon-flag-parcours.svg?component';
  import IconHelp from '@/assets/img/refonte/icons/information/icon-help.svg?component';
  import IconHourglass from '@/assets/img/refonte/icons/information/icon-hourglass.svg?component';
  import IconInformation from '@/assets/img/refonte/icons/information/icon-information.svg?component';
  import IconList from '@/assets/img/refonte/icons/information/icon-list.svg?component';
  import IconLocation from '@/assets/img/refonte/icons/information/icon-location.svg?component';
  import IconLunch from '@/assets/img/refonte/icons/information/icon-lunch.svg?component';
  import IconMultipleDates from '@/assets/img/refonte/icons/information/icon-multiple-dates.svg?component';
  import IconOnline from '@/assets/img/refonte/icons/information/icon-online.svg?component';
  import IconPhone from '@/assets/img/refonte/icons/information/icon-phone.svg?component';
  import IconTestPositionnement from '@/assets/img/refonte/icons/information/icon-test-positionnement.svg?component';
  import IconTestValidation from '@/assets/img/refonte/icons/information/icon-test-validation.svg?component';
  import IconTime from '@/assets/img/refonte/icons/information/icon-time.svg?component';
  import IconValidate from '@/assets/img/refonte/icons/information/icon-validate.svg?component';
  import IconValidate20 from '@/assets/img/refonte/icons/information/icon-validate-20.svg?component';
  import IconWarning20 from '@/assets/img/refonte/icons/information/icon-warning-sign-20.svg?component';
  import IconBills from '@/assets/img/refonte/icons/menu/icon-bills.svg?component';
  import IconCatalogue from '@/assets/img/refonte/icons/menu/icon-catalogue.svg?component';
  import IconDashboard from '@/assets/img/refonte/icons/menu/icon-dashboard.svg?component';
  import IconEntities from '@/assets/img/refonte/icons/menu/icon-entities.svg?component';
  import IconOrders from '@/assets/img/refonte/icons/menu/icon-orders.svg?component';
  import IconParticipants from '@/assets/img/refonte/icons/menu/icon-trainees.svg?component';
  import IconTraining from '@/assets/img/refonte/icons/menu/icon-training.svg?component';
  import IconUser from '@/assets/img/refonte/icons/menu/icon-user.svg?component';
  import IconEspace from '@/assets/img/refonte/icons/profil/icon-espace.svg?component';
  import IconPastilleActive from '@/assets/img/refonte/icons/states/icon-pastille-active.svg?component';
  import IconPastilleCanceled from '@/assets/img/refonte/icons/states/icon-pastille-canceled.svg?component';
  import IconPastilleDeactivated from '@/assets/img/refonte/icons/states/icon-pastille-deactivated.svg?component';
  import IconPastilleEntreprise from '@/assets/img/refonte/icons/states/icon-pastille-entreprise.svg?component';
  import IconPastilleFormateur from '@/assets/img/refonte/icons/states/icon-pastille-formateur.svg?component';
  import IconPastilleParticipant from '@/assets/img/refonte/icons/states/icon-pastille-participant.svg?component';
  import IconPastilleCursus from '@/assets/img/refonte/icons/states/icon-pastille-cursus.svg?component';
  import IconPastillePending from '@/assets/img/refonte/icons/states/icon-pastille-pending.svg?component';
  import IconPastilleRealised from '@/assets/img/refonte/icons/states/icon-pastille-realised.svg?component';
  import IconPastilleUrgent from '@/assets/img/refonte/icons/states/icon-pastille-urgent.svg?component';
  import IconPastilleWarning from '@/assets/img/refonte/icons/states/icon-pastille-warning.svg?component';
  import IconConventionCollective from '@/assets/img/refonte/icons/users/icon-convention-collective.svg?component';
  import IconMyAccount from '@/assets/img/refonte/icons/users/icon-my-account.svg?component';
  import IconNotAttended from '@/assets/img/refonte/icons/users/icon-not-attended.svg?component';
  import IconTrainingProvider from '@/assets/img/refonte/icons/users/icon-training-provider.svg?component';
  import RefonteCard from '@/components/refonte/cards/refonte-card.vue';
  import IconPastilleControlleurEc from '@/assets/img/refonte/icons/states/icon-pastille-controlleur-ec.svg?component';
</script>

<style lang="scss" scoped>
  .refonte-icon {
    @apply flex shrink-0 items-center justify-center;

    :deep(svg) {
      @apply text-refonte-black;
      width: 24px;
      height: 24px;
    }
  }
</style>
